import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import service from "../services/configuraciones.service";


const initialState = {
    configuracionesList:[],
    configuraciones:null,
    isLoading: false,
    isError: false,
    message: '',// Mensaje de error general
};


export const getConfiguraciones = createAsyncThunk(
    "configuraciones/getConfiguraciones",
    async (_, thunkAPI) => {
        try {
            return await service.getConfiguraciones();
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateConfiguraciones = createAsyncThunk(
    "configuraciones/update",
    async (data, thunkAPI) => {
        try {
            return await service.updateConfiguraciones(data);
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);


const configuracionesSlice = createSlice({
    name: "configuraciones",
    initialState,
    reducers: {
        reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getConfiguraciones.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getConfiguraciones.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.configuracionesList = action.payload;
            })
            .addCase(getConfiguraciones.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updateConfiguraciones.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateConfiguraciones.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.configuraciones = action.payload;
            })
            .addCase(updateConfiguraciones.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            
    },
});
export const { reset } = configuracionesSlice.actions;
export default configuracionesSlice.reducer;
